import 'url-search-params-polyfill';
import TradingViewWidget from 'react-tradingview-widget';

export const TradingchartPreview = (props) => {

    return (
        <TradingViewWidget
            symbol={props?.symbol}
            height={props?.height}
            width="100vw"
            theme="light"
            locale="en"
            interval={"D"}
            timezone={"Etc/UTC"}
            enable_publishing={false}
            allow_symbol_change={false}
            container_id="tradingview"
        />
    );
}
